import Box from '@mui/material/Box';
import React, { useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { constants } from '../../constants';
import useMyMApi from '../../hooks/useMyMApi';
import useWebContext from '../../hooks/useWebContext';
import { BreadcrumbItemContext } from '../../provider/BreadcrumbItemContextProvider';
import { MyMModal } from '../../ui-elements/MyMModal';
import { MyMProgress } from '../../ui-elements/MyMProgress';
import CustomAccordion from '../../ui-parts/CustomAccordion';
import Preview, { previewModalSize } from '../MyM906_Preview/Preview';
import { ServiceLv3MetadataTabs } from './ServiceLv3MetadataTabs';
import { MyMVariantLabel } from '../../ui-elements/MyMLabel';
import Grid from '@mui/material/Grid';
import { mediaQuery, useMediaQuery } from '../../hooks/useMediaQuery';

/** MyMine Version2.0 ServiceLv3画面新規追加
 * ServiceLv3 Page Component
 */
const ServiceLv3 = () => {

  const screenId = 'MyM323';
  const queryParam = useParams();
  const location = useLocation();
  const { setBreadcrumbItem } = useContext(BreadcrumbItemContext);
  const { controlSettings } = useWebContext(screenId);
  const apiRequest = useMyMApi(screenId);
  const [isLoading, setIsLoading] = useState(true);
  const [postDeliveryContentsList, setPostDeliveryContentsList] = useState(null);
  const navigate = useNavigate();
  const [previewFileId, setPreviewFileId] = useState(null);
  const handleModalClose = () => setPreviewFileId(null);
  const { breadcrumbItem } = useContext(BreadcrumbItemContext);
  const isPc = useMediaQuery(mediaQuery.pc);
  const boxWidth = isPc ? '100%' : '95%';

  useEffect(() => {

    /**
     * Contents情報取得成功時処理
     * @param {any} result
     */
    const callbackSuccessRequestServiceContents = (result) => {

      if (result === null) {
        // 取得情報がない場合、失敗処理を行う
        callbackFailedRequestServiceContents();
        return;
      }

      // パンくずリストにMetadataNameを設定
      setBreadcrumbItem(location.state?.breadcrumb);
      setPostDeliveryContentsList(result.PoseDeliveryMetadataList);
      setIsLoading(false);
    }

    /**
     * Contents情報取得失敗時処理
     */
    const callbackFailedRequestServiceContents = () => {
      setIsLoading(false);
      // エラーページ遷移
      navigate('/MyM999', { state: { message: constants.Message.InvalidRequest } });
    }

    // 表示情報取得
    apiRequest.requestJson(`api/service/lv3?metadataId=${queryParam.metadata_id}`, 'GET', callbackSuccessRequestServiceContents, callbackFailedRequestServiceContents)

    // アンマウント時、パンくずリストのコンテキストをクリア
    return () => {
      setBreadcrumbItem(null);
    }
  }, []);


  /**
  * お気に入りファイルコールバック処理
  * @param {number} favoriteFileId お気に入りファイルID
  */
  const callbackFileFavorite = (favoriteFileId) => {
    // Stateのお気に入り情報を更新
    postDeliveryContentsList.forEach(contentsMetadata => {
      const metadataContentsFavFile = contentsMetadata.BoxFileList.find(x => x.FileId === favoriteFileId);
      if (metadataContentsFavFile)
        metadataContentsFavFile.IsFavorite = !metadataContentsFavFile.IsFavorite;
    })
  }

  /**
  * お気に入りIt Appコールバック処理
  * @param {number} favoriteItAppId お気に入りIt AppID
  */
  const callbackItAppFavorite = (favoriteItAppId) => {
    // Stateのお気に入り情報を更新
    postDeliveryContentsList.forEach(contentsMetadata => {
      const metadataContentsFavItApp = contentsMetadata.ItAppList.find(x => x.ItAppId === favoriteItAppId);
      if (metadataContentsFavItApp)
        metadataContentsFavItApp.IsFavorite = !metadataContentsFavItApp.IsFavorite;
    })
  }

  if (postDeliveryContentsList == null)
    return <MyMProgress />

  return (
    <Box className='py-1 d-flex flex-column align-items-center' >
      {isLoading && <MyMProgress />}
      <Grid container sx={{minHeight: 30}}>
        <Grid item xs={12}>
          <MyMVariantLabel variant='h5' sx={{ left: '1%' }}>{breadcrumbItem}</MyMVariantLabel>
        </Grid>
      </Grid>
      {postDeliveryContentsList.map((postDeliveryContents, i) =>
        <Box width={boxWidth} key={i}>
          <CustomAccordion
            menuText={postDeliveryContents.MetadataName}
            contents={
              <ServiceLv3MetadataTabs
                controlSettings={controlSettings}
                screenId={screenId}
                callbackFileFavorite={callbackFileFavorite}
                callbackItAppFavorite={callbackItAppFavorite}
                metadataContents={postDeliveryContents}
                setIsLoading={setIsLoading}
              />}
          />
        </Box>
      )}
      <MyMModal
        open={previewFileId !== null}
        onClose={handleModalClose}
        {...previewModalSize}
      >
        <Preview fileId={previewFileId} onPreviewFailed={handleModalClose} />
      </MyMModal>
    </Box>
  );
}
export default ServiceLv3;
